var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DisplayContainer',{staticStyle:{"background-color":"transparent"},attrs:{"isSubcomponent":""}},[_c('external-user-table',{attrs:{"companies":_vm.companies,"realm":_vm.realm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }